/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import AnalyticsService from 'cio/services/analytics';
import { inject as service } from '@ember/service';
import FacebookLeadAdsForm from 'cio/models/facebook-lead-ads-form';
import CustomForm from 'cio/models/custom-form';
import CustomFormsService from 'cio/services/custom-forms';
import { isCustomForm } from 'cio/utils/forms';

interface FormsCustomIntegrationDetailsArgs {
  form: FacebookLeadAdsForm | CustomForm | null;
  isSuccessModal?: boolean;
  isTypeformBlankSlate?: boolean;
  isJotformBlankSlate?: boolean;
  detailsToShow?: FormIntegrationDetailPanes;
  compact?: boolean;
}

export enum FormIntegrationDetailPanes {
  JavaScriptSnippet = 'js_snippet_details',
  FormsEndpoint = 'forms_endpoint_details',
  HTMLAction = 'html_action',
  Typeform = 'typeform_details',
  Jotform = 'jotform',
}

export default class FormsCustomIntegrationDetails extends Component<FormsCustomIntegrationDetailsArgs> {
  @service analytics!: AnalyticsService;
  @service customForms!: CustomFormsService;

  @tracked visiblePane: FormIntegrationDetailPanes | null = null;
  readonly panes = FormIntegrationDetailPanes;

  @action
  onCopy(
    content:
      | 'Forms Endpoint URL'
      | 'Forms Endpoint Code'
      | 'JS Snippet'
      | 'HTML Action - submit URL'
      | 'HTML Action - example HTML',
  ) {
    let language: string | undefined;

    if (content === 'Forms Endpoint Code') {
      language = 'cURL'; // currently only copy-able code example
    }

    this.analytics.track('forms', 'custom_form_code_copied', {
      type: content,
      language,
    });
  }

  @action
  show(pane: FormIntegrationDetailPanes) {
    this.visiblePane = pane;
    this.analytics.track('forms', 'custom_form_code_viewed', {
      type: pane,
    });
  }

  constructor(owner: unknown, args: FormsCustomIntegrationDetailsArgs) {
    super(owner, args);

    if (this.args.detailsToShow != null) {
      this.show(this.args.detailsToShow);
    } else if (this.args.form != null && isCustomForm(this.args.form) && this.args.form.isApiForm) {
      this.show(FormIntegrationDetailPanes.FormsEndpoint);
    } else if (this.args.form != null && isCustomForm(this.args.form) && this.args.form.isHTMLActionForm) {
      this.show(FormIntegrationDetailPanes.HTMLAction);
    } else {
      this.show(FormIntegrationDetailPanes.JavaScriptSnippet);
    }
  }
}
